/* eslint-disable jsx-a11y/anchor-is-valid */
import React, {useEffect} from 'react'
import { Redirect, Route, Switch, useHistory } from 'react-router-dom'
import { Registration } from './components/Registration'
import { ForgotPassword } from './components/ForgotPassword'
import { ResetPassword } from './components/ResetPassword';
import { Login } from './components/Login'
import { toAbsoluteUrl } from '../../../_metronic/helpers'
import { Login2Fa } from './components/Login2Fa'
import { LoginPage } from './components/LoginPage'
import { AuthContextProvider } from './context/AuthContext';
import Setup2Fa from './components/Setup2Fa';
import Option2Fa from './components/Option2Fa';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3'

export function AuthPage() {

  const history = useHistory();
  const recaptchaKey = process.env.REACT_APP_RECAPTCHA ?? ''

  useEffect(() => {
    document.body.classList.add('auth-app')
    return () => {
      document.body.classList.remove('auth-app')
    }
  }, [])

  return (
    <div className='container-fluid min-vh-100 p-0 auth-layout'>
      <div className='row min-vh-100 m-0 auth-grid'>
        <div className='col-md-4 d-flex flex-column align-items-center justify-content-center auth-panel-column'>
          <div className='w-lg-500px p-6 p-lg-10 mx-auto auth-panel' style={{ maxWidth: '100%' }}>
            <div className='text-center mb-4'>
              <a href='#'>
                <img alt='WebCert Logo' src={toAbsoluteUrl('/media/logos/WebCert-logo.png')} className='h-90px' />
              </a>
            </div>
            {recaptchaKey ? (
              <GoogleReCaptchaProvider
                reCaptchaKey={recaptchaKey}
                scriptProps={{async: true, defer: true}}
                container={{
                  parameters: {
                    badge: 'bottomright',
                    theme: 'light',
                  },
                }}
              >
                <AuthContextProvider>
                  <Switch>
                    <Route path='/auth/login' exact component={LoginPage} />
                    <Route path='/auth/login-2fa' render={() => <Login2Fa cancelHandler={() => { history.push('/auth/login') }} />} />
                    <Route path='/auth/setup-2fa' exact component={Setup2Fa} />
                    <Route path='/auth/option-2fa' exact component={Option2Fa} />
                    <Route path='/auth/reset-password' exact component={ResetPassword} />
                    <Route path='/auth/registration' exact component={Registration} />
                    <Route path='/auth/forgot-password' exact component={ForgotPassword} />
                    <Redirect from='/auth' exact to='/auth/login' />
                    <Redirect to='/auth/login' />
                  </Switch>
                </AuthContextProvider>
              </GoogleReCaptchaProvider>
            ) : (
              <AuthContextProvider>
                <Switch>
                  <Route path='/auth/login' exact component={LoginPage} />
                  <Route path='/auth/login-2fa' render={() => <Login2Fa cancelHandler={() => { history.push('/auth/login') }} />} />
                  <Route path='/auth/setup-2fa' exact component={Setup2Fa} />
                  <Route path='/auth/option-2fa' exact component={Option2Fa} />
                  <Route path='/auth/reset-password' exact component={ResetPassword} />
                  <Route path='/auth/registration' exact component={Registration} />
                  <Route path='/auth/forgot-password' exact component={ForgotPassword} />
                  <Redirect from='/auth' exact to='/auth/login' />
                  <Redirect to='/auth/login' />
                </Switch>
              </AuthContextProvider>
            )}
            <div className='text-center text-gray-500 fw-semibold mt-6'>
              &copy; {new Date().getFullYear()} WebCert Solutions
            </div>
          </div>
        </div>

        <div className='col-md-8 d-none d-md-flex justify-content-center align-items-center bgi-position-y-center position-x-center bgi-size-contain bgi-attachment-fixed auth-hero'
          style={{
            backgroundImage: `url('${toAbsoluteUrl('https://static.wixstatic.com/media/686a6e_19e77d3db2a34a71afef3a2499f830b1~mv2.jpg/v1/fill/w_1000,h_466,al_c,q_85,enc_auto/686a6e_19e77d3db2a34a71afef3a2499f830b1~mv2.jpg')}')`,
            backgroundSize: 'cover',
            backgroundPosition: 'center center'
          }}>
          <div className='text-center auth-hero__content'>
            <h1 className='mb-6 auth-hero__headline' style={{ fontSize: '3.75rem' }}>
              Australia's leading provider of independent end-to-end project services.
            </h1>
          </div>
        </div>
      </div>
    </div>


    
  )
}

